// Web stand-in for @react-native-community/slider (aliased in
// webpack.config.web.js). Real range-input implementation, not a dummy —
// VoiceMessageBubble.tsx renders this unconditionally (not behind a
// Platform.OS check), so it needs to actually work, not just avoid
// crashing.
import React from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';

type SliderProps = {
  style?: ViewStyle;
  value?: number;
  minimumValue?: number;
  maximumValue?: number;
  minimumTrackTintColor?: string;
  maximumTrackTintColor?: string;
  thumbTintColor?: string;
  disabled?: boolean;
  onValueChange?: (value: number) => void;
  onSlidingComplete?: (value: number) => void;
};

const Slider: React.FC<SliderProps> = ({
  style,
  value = 0,
  minimumValue = 0,
  maximumValue = 1,
  minimumTrackTintColor = '#fff',
  thumbTintColor,
  disabled,
  onValueChange,
  onSlidingComplete,
}) => (
  <View style={style}>
    <input
      type="range"
      min={minimumValue}
      max={maximumValue}
      step={(maximumValue - minimumValue) / 1000 || 0.001}
      value={value}
      disabled={disabled}
      onChange={event => onValueChange?.(Number(event.target.value))}
      onMouseUp={event => onSlidingComplete?.(Number((event.target as HTMLInputElement).value))}
      onTouchEnd={event => onSlidingComplete?.(Number((event.target as HTMLInputElement).value))}
      style={{
        width: '100%',
        accentColor: thumbTintColor || minimumTrackTintColor,
        ...styles.rangeInput,
      }}
    />
  </View>
);

const styles = { rangeInput: { cursor: 'pointer' } } as const;

export default Slider;
